import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomePage } from './pages/home-page/home-page.component';
import { SobrePage } from './pages/sobre-page/sobre-page.component';
import { ModulosResolver } from './resolvers/modulos.resolver';
import { CarrinhoPage } from './pages/cart-page/cart-page.component';
import { ServicosPage } from './pages/servico/servicos-page/servicos-page.component';
import { ServicoPage } from './pages/servico/servico-page/servico-page.component';
import { CidadesPage } from './pages/a-serra-gaucha/cidades-page/cidades-page.component';
import { CidadePage } from './pages/a-serra-gaucha/cidade-page/cidade-page.component';
import { PagamentoPage } from './pages/pagamento-page/pagamento-page.component';
import { TrabalheConoscoPage } from './pages/trabalhe-conosco-page/trabalhe-conosco-page.component';
import { FotosPage } from './pages/fotos-page/fotos-page.component';
import { MinhasViagensPage } from './pages/minhas-viagens-page/minhas-viagens-page.component';
import { ListaDesejosPage } from './pages/lista-desejos-page/lista-desejos-page.component';
import { PagafacilPage } from './pages/pagafacil-page/pagafacil-page.component';
import { PoliticaDeCancelamentoPage } from './pages/politica-de-cancelamento-page/politica-de-cancelamento-page.component';
import { PoliticaDeSegurancaPage } from './pages/politica-de-seguranca-page/politica-de-seguranca-page.component';
import { PoliticaDePrivacidadePage } from './pages/politica-de-privacidade-page/politica-de-privacidade-page.component';
import { ContatoPageComponent } from './pages/contato-page/contato-page.component';
import { MeusServicosPage } from './pages/meus-servicos-page/meus-servicos-page.component';
import { PagamentoConfirmacaoPage } from './pages/pagamento-confirmacao-page/pagamento-confirmacao-page.component';

const routes: Routes = [{ 
  path: '', 
  component: HomePage, 
  resolve:{
    modulos: ModulosResolver
  }
},{
  path: 'sobre',
  component: SobrePage, 
  resolve:{
    modulos: ModulosResolver
  }
},{
  path: 'minhas-viagens', 
  component: MinhasViagensPage,    
  resolve:{
    modulos: ModulosResolver
  }
},{
  path: 'lista-de-desejos', 
  component: ListaDesejosPage,     
  resolve:{
    modulos: ModulosResolver
  }
},{
  path: 'carrinho',
  component: CarrinhoPage, 
  resolve:{
    modulos: ModulosResolver
  }
},{
  path: 'carrinho/finalizar-compra',
  component: PagamentoPage,
  resolve:{ 
    modulos: ModulosResolver
  }
},{
  path: 'carrinho/finalizar-compra/confirmacao',  
  component: PagamentoConfirmacaoPage, 
  resolve:{ 
    modulos: ModulosResolver
  }
},{
  path: 'servicos',
  component: ServicosPage,
  resolve:{ 
    modulos: ModulosResolver
  }
},{
  path: 'buscar',
  component: ServicosPage,
  resolve:{ 
    modulos: ModulosResolver
  }
},{
  path: 'servicos/:apelido_categoria', 
  component: ServicosPage, 
  resolve:{
    modulos: ModulosResolver,
  }
},{
  path: 'servicos/:apelido_categoria/:apelido_produto',
  component: ServicoPage,
  resolve:{
    modulos: ModulosResolver
  }
},{
  path: 'a-serra-gaucha/:apelido',
  component: CidadePage,
  resolve:{ 
    modulos: ModulosResolver
  }
},{
  path: 'a-serra-gaucha',
  component: CidadesPage,
  resolve:{ 
    modulos: ModulosResolver
  }
},{
  path: 'trabalhe-conosco',   
  component: TrabalheConoscoPage,     
  resolve:{
    modulos: ModulosResolver
  }
},{
  path: 'fotos',   
  component: FotosPage,      
  resolve:{
    modulos: ModulosResolver
  }
},{
  path: 'pedido/pagafacil/:file',   
  component: PagafacilPage, 
  resolve:{ 
    modulos: ModulosResolver
  }
},{
  path: 'politica-de-cancelamento-e-reembolso',
  component: PoliticaDeCancelamentoPage, 
  resolve:{
    modulos: ModulosResolver
  }
},{
  path: 'politica-de-privacidade',
  component: PoliticaDePrivacidadePage, 
  resolve:{
    modulos: ModulosResolver
  }
},{
  path: 'politica-de-seguranca', 
  component: PoliticaDeSegurancaPage,  
  resolve:{
    modulos: ModulosResolver
  }
},{
  path: 'meus-servicos', 
  component: MeusServicosPage,  
  resolve:{
    modulos: ModulosResolver
  }
},{
  path: 'contato',  
  component: ContatoPageComponent,  
  resolve:{
    modulos: ModulosResolver
  }
},{  
  path: '**',
  pathMatch: 'full',
  redirectTo: ''
}];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
